export const SET_ACTIVE_GROUP = 'Filters/SET_ACTIVE_GROUP';
export const setActiveGroup = (groupSelection) => {
  const id =
    groupSelection && groupSelection.value !== 'all-value'
      ? groupSelection.value
      : null;

  return {
    type: SET_ACTIVE_GROUP,
    payload: { id },
  };
};

export const SET_ACTIVE_STATUS = 'Filters/SET_ACTIVE_STATUS';
export const setActiveStatus = (activeStatusSelection) => {
  const status =
    activeStatusSelection && activeStatusSelection.value !== 'all-value'
      ? activeStatusSelection.value
      : null;

  return {
    type: SET_ACTIVE_STATUS,
    payload: { status },
  };
};

export const RESET_FILTERS = 'Filters/RESET_FILTERS';
export const resetFilters = () => ({
  type: RESET_FILTERS,
});
